// import { configureStore } from "@reduxjs/toolkit";
// import cartSlice from "./cartSlice";
// import userSlice from './userSlice'

// export default configureStore({
//   reducer: {
//     user: userSlice,
//     cart: cartSlice
//   },
// });

import { configureStore } from "@reduxjs/toolkit";
import cartSlice from "./cartSlice";
import userSlice from "./userSlice";

import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage"; // localStorage for web

// Persist config for user slice only
const userPersistConfig = {
  key: "user",
  storage,
};

// Wrap the user reducer with persistReducer
const persistedUserReducer = persistReducer(userPersistConfig, userSlice);

export const store = configureStore({
  reducer: {
    user: persistedUserReducer,
    cart: cartSlice, // cart will not be persisted
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

// Create persistor to use in PersistGate
export const persistor = persistStore(store);
